export enum AppointmentStatus {
  Approved = "Approved",
  Blocked = "Blocked",
  Canceled = "Canceled",
  Pending = "Pending",
}
